import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/default-profile.png'
import _imports_1 from '@/assets/img/icon/red-card-fill.png'
import _imports_2 from '@/assets/img/icon/yellow-card-fill.png'


const _hoisted_1 = { class: "rounded-xl border-grey-3 p-4 my-4" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = { class: "inline-flex" }
const _hoisted_4 = { class: "rounded-xl border-grey-3 background-grey-1 p-4" }
const _hoisted_5 = { class: "md:flex items-center gap-3 justify-between" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = { class: "text-base font-bold" }
const _hoisted_8 = { class: "text-grey-5" }
const _hoisted_9 = { class: "flex items-center gap-3 justify-end" }
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "text-red font-bold" }
const _hoisted_12 = { class: "flex items-center gap-3" }
const _hoisted_13 = { class: "text-orange-1 font-bold" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex-none" }
const _hoisted_16 = { class: "text-base font-bold" }
const _hoisted_17 = { class: "text-xs text-grey-5 font-semibold" }
const _hoisted_18 = { class: "flex-auto" }
const _hoisted_19 = { class: "flex items-top gap-4" }
const _hoisted_20 = { class: "flex-none w-100px" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "mb-3",
  id: "shorten"
}
const _hoisted_26 = { class: "flex-none" }
const _hoisted_27 = ["onClick"]

import apiUseCase from '@/usecase/apiUseCase'
import moment from 'moment'
import { computed, watch, onMounted, getCurrentInstance, ref, reactive } from 'vue'
import { useStore } from 'vuex'
import Button from 'primevue/button'
import Popper from 'vue3-popper'
import numberFormat from '@/utils/helpers/numberFormat'
import { getDynamicStatusBg, getDynamicStatusColor, getDynamicStatusName, getDynamicStatusIcon } from '@/utils/helpers/colorStatusLabel'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import cardLabelList from '../cardLabelList'
import cardStatusList from '../cardStatusList'

const employeePenaltyEndpoint = 'talent/v1/employeePenalties'
const employeeEndpoint = 'talent/v1/employees'

export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeViolationHistory',
  props: {
  data: {
    default: null as any
  }
},
  setup(__props) {

const props = __props

const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const store = useStore()
const employeeData = computed(() => props.data)
const dataSource = ref([]) as any
const selectedViolenceHistory = ref<number[]>([])
const employeePenaltySummary = ref([]) as any

const attrModalPrintConfirmation = reactive({
  show: false,
  title: 'Download Pelanggaran?',
  subTitle: 'Pelanggaran yang bisa didownload hanya pelanggaran yang statusnya <span class="text-primary font-bold underline">Final</span>. Lanjut download pelanggaran?',
  btnSubmitTitle: 'Download Pelanggaran',
  btnBackTitle: 'Kembali',
  subTitleHtml: true,
  imgContent: require('@/assets/img/modal-confirmation/finalize-penalty-card.png')
})

const countFinalPenaltyCards = computed(() => {
  if (!Array.isArray(dataSource.value) || dataSource.value.length === 0) {
    return 0
  }
  return dataSource.value.filter((item: any) => String(item.status)?.toLowerCase() === 'finalized').length
})

const getEmployeeViolationHistory = () => {
  store.dispatch('showLoading')
  apiUseCase.get(`${employeeEndpoint}/${employeeData.value?.id}/penalties`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getEmployeePenaltiesSummaryAct = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${employeeData.value?.id}/penalties/summary`).then((response) => {
    const { error, result } = response
    if (!error) {
      employeePenaltySummary.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getPenaltySummaryCount = (penaltyTypeName: string) => {
  const summaries = employeePenaltySummary.value
  if (!Array.isArray(summaries) || summaries.length === 0) {
    return 0
  }

  const summary = summaries.find((item: any) => (
    (item.penaltyTypeName ?? item.PenaltyTypeName)?.toLowerCase() === penaltyTypeName.toLowerCase()
  ))
  if (!summary) {
    return 0
  }

  return numberFormat(Number(summary.count ?? summary.Count ?? 0))
}

const toggleViolenceHistory = (id: number) => {
  const selectedIndex = selectedViolenceHistory.value.indexOf(id)
  if (selectedIndex === -1) {
    selectedViolenceHistory.value.push(id)
  } else {
    selectedViolenceHistory.value.splice(selectedIndex, 1)
  }
}

const printEmployeePenaltyCards = async () => {
  // eslint-disable-next-line no-use-before-define
  hideDialogPrintConfirmation()
  store.dispatch('showLoading')
  try {
    const { error, result, message } = await apiUseCase.getBlob(`${employeeEndpoint}/${employeeData.value?.id}/penalties/export`)
    if (error) {
      $toast.add({
        severity: 'error',
        summary: 'Dokumen gagal didownload',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
      return
    }

    let blob: Blob
    if (result instanceof Blob) {
      const signature = await result.slice(0, 5).text()
      if (signature === '%PDF-') {
        blob = result
      } else {
        // eslint-disable-next-line no-use-before-define
        blob = await createPdfBlob(await result.text())
      }
    } else {
      // eslint-disable-next-line no-use-before-define
      blob = await createPdfBlob(result)
    }

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `Kartu Pelanggaran ${employeeData.value?.fullName ?? '-'} (${moment().format('DD MMMM YYYY')}).pdf`
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    $toast.add({
      severity: 'success',
      detail: 'Data berhasil didownload',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Dokumen gagal didownload',
      detail: error instanceof Error ? error.message : 'Terjadi kesalahan saat mengunduh dokumen',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } finally {
    store.dispatch('hideLoading')
  }
}

const createPdfBlob = (value: unknown): Blob => {
  let fileData = value
  if (typeof fileData === 'string') {
    try {
      const parsed = JSON.parse(fileData)
      fileData = typeof parsed === 'string' ? parsed : parsed.Data ?? parsed.data
    } catch (error) {
      if (fileData.trimStart().startsWith('{')) {
        throw error
      }
    }
  }

  if (typeof fileData !== 'string') {
    throw new Error('Format dokumen dari server tidak valid')
  }

  const base64 = fileData
    .replace(/^data:application\/pdf;base64,/i, '')
    .replace(/\s/g, '')
  if (!base64.startsWith('JVBER')) {
    throw new Error('Data PDF dari server tidak valid')
  }

  const binary = window.atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index)
  }
  return new Blob([bytes], { type: 'application/pdf' })
}

const showPrintPenaltyConfirmation = () => {
  attrModalPrintConfirmation.show = true
}

const hideDialogPrintConfirmation = () => {
  attrModalPrintConfirmation.show = false
}

onMounted(() => {
  getEmployeeViolationHistory()
  getEmployeePenaltiesSummaryAct()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-lg font-bold" }, "Riwayat Pelanggaran", -1)),
          _createVNode(_unref(Popper), {
            arrow: "",
            hover: countFinalPenaltyCards.value === 0,
            placement: "bottom",
            content: "Karyawan tidak memilikik kartu pelanggaran dengan status Final",
            disabled: countFinalPenaltyCards.value > 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_unref(Button), {
                  class: "extra-submit-button p-small-btn flex gap-x-2 mt-3",
                  style: {"border-color":"#04776D"},
                  outlined: true,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showPrintPenaltyConfirmation())),
                  disabled: countFinalPenaltyCards.value === 0
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "pi pi-download text-primary text-sm" }, null, -1),
                    _createElementVNode("p", { class: "text-primary font-bold text-sm" }, _toDisplayString('Download Pelanggaran'), -1)
                  ])),
                  _: 1,
                  __: [2]
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["hover", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                src: _imports_0,
                width: "50",
                class: "rounded-full",
                alt: "photo"
              }, null, -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(__props.data?.fullName ?? '-'), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(`${__props.data?.employments.length > 0 ? __props.data?.employments[__props.data?.employments.length - 1].positionName : '-'} | ${__props.data?.personnelNumber ?? '-'}`), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(getPenaltySummaryCount('Kartu Merah')), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                    src: _imports_1,
                    alt: "merah"
                  }, null, -1))
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-grey-5" }, "Kartu Merah", -1))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(getPenaltySummaryCount('Kartu Kuning')), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("img", {
                    src: _imports_2,
                    alt: "kuning"
                  }, null, -1))
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-grey-5" }, "Kartu Kuning", -1))
              ])
            ])
          ])
        ]),
        (dataSource.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataSource.value, (data) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: data,
                  class: "flex rounded-xl border-grey-3 gap-4 p-4 mt-4"
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(moment)(data.createdAt).format('DD MMMM YYYY')), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(moment)(data.createdAt).format('HH:mm:ss')) + " WIB", 1),
                    _createElementVNode("div", {
                      style: _normalizeStyle({
                backgroundColor: _unref(getDynamicStatusBg)(_unref(cardStatusList), String(data?.status))
              }),
                      class: "flex items-center gap-2 rounded-lg px-4 py-1 w-fit"
                    }, [
                      _createElementVNode("div", {
                        style: _normalizeStyle({
                  color: _unref(getDynamicStatusBg)(_unref(cardStatusList), String(data?.status)),
                  backgroundColor: _unref(getDynamicStatusColor)(_unref(cardStatusList), String(data?.status))
                }),
                        class: "rounded-full px-1 py-1 flex items-center justify-center"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(_unref(getDynamicStatusIcon)(_unref(cardStatusList), String(data?.status)))
                        }, null, 2)
                      ], 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle({ color: _unref(getDynamicStatusColor)(_unref(cardStatusList), String(data?.status)) }),
                        class: "text-sm font-semibold"
                      }, _toDisplayString(_unref(getDynamicStatusName)(_unref(cardStatusList), String(data?.status))), 5)
                    ], 4)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", {
                          class: "text-xs font-bold px-3 py-1 rounded-full border transition-all duration-200",
                          style: _normalizeStyle({
                    color: _unref(getDynamicStatusColor)(_unref(cardLabelList), data.penaltyTypeName),
                    borderColor: _unref(getDynamicStatusColor)(_unref(cardLabelList), data.penaltyTypeName),
                    backgroundColor: _unref(getDynamicStatusBg)(_unref(cardLabelList), data.penaltyTypeName)
                  })
                        }, _toDisplayString(data.penaltyTypeName), 5)
                      ]),
                      (selectedViolenceHistory.value.includes(data.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(data.description), 1),
                            (data.evidenceUrl)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "font-semibold" }, "Foto Pendukung: ", -1)),
                                  _createElementVNode("img", {
                                    src: data?.evidenceUrl,
                                    width: "150",
                                    class: "rounded-xl",
                                    alt: "photo"
                                  }, null, 8, _hoisted_24)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(data.description.length > 100 ? `${data.description.slice(0, 100)}...` : data.description), 1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (data.description.length > 100 || data?.evidenceUrl)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass([
                selectedViolenceHistory.value.includes(data.id) ? 'pi pi-angle-up' : 'pi pi-angle-down',
                'background-grey-3 rounded-full px-2 py-1 cursor-pointer'
              ]),
                          onClick: ($event: any) => (toggleViolenceHistory(data.id))
                        }, null, 10, _hoisted_27))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(HjpConfirmationModal, {
      show: attrModalPrintConfirmation.show,
      title: attrModalPrintConfirmation?.title,
      subTitle: attrModalPrintConfirmation?.subTitle,
      btnSubmitTitle: attrModalPrintConfirmation?.btnSubmitTitle,
      btnBackTitle: attrModalPrintConfirmation?.btnBackTitle,
      subTitleHtml: attrModalPrintConfirmation?.subTitleHtml,
      imgContent: attrModalPrintConfirmation.imgContent,
      onHideDialog: hideDialogPrintConfirmation,
      onOnSubmit: _cache[1] || (_cache[1] = ($event: any) => (printEmployeePenaltyCards()))
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "btnBackTitle", "subTitleHtml", "imgContent"])
  ], 64))
}
}

})